import * as React from 'react';
import { useIntl } from '@leagueplatform/locales';
import { Modal } from '@leagueplatform/genesis-core';
import type { EnvironmentData } from '@web-config-app/core-react';
import type { TreeNode } from '@web-config-app/core';
import { EntityDataTableModalContents } from './entity-data-table-modal-contents.component';
import { TextActionButtonIcon } from '../text-action-button-icon/text-action-button-icon.component';
import type { SyncModeConfig } from './sync-mode.types';

export interface EntityDataTableModalProps {
  currentEnvironmentData: EnvironmentData;
  otherEnvironmentData?: EnvironmentData;
  entityName: string | undefined;
  dataPath?: string;
  entityTreeNodeMap: Map<string, TreeNode>;
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  syncMode?: SyncModeConfig;
}

export const EntityDataTableModal = ({
  currentEnvironmentData,
  otherEnvironmentData,
  entityTreeNodeMap,
  entityName,
  dataPath,
  isOpen,
  onOpenChange,
  syncMode,
}: EntityDataTableModalProps) => {
  const { formatMessage } = useIntl();

  return (
    <Modal.Root open={isOpen} onOpenChange={onOpenChange}>
      <Modal.Trigger>
        {!syncMode && (
          <TextActionButtonIcon
            icon="descriptiveDocument"
            label={formatMessage({ id: 'VIEW_ALL_DATA' })}
            size="1.25rem"
          />
        )}
      </Modal.Trigger>

      {isOpen && (
        <Modal.Content layout="fullscreen" showCloseButton={false}>
          <EntityDataTableModalContents
            currentEnvironmentData={currentEnvironmentData}
            otherEnvironmentData={otherEnvironmentData}
            entityName={entityName}
            dataPath={dataPath}
            entityTreeNodeMap={entityTreeNodeMap}
            onOpenChange={onOpenChange}
            syncMode={syncMode}
          />
        </Modal.Content>
      )}
    </Modal.Root>
  );
};
